<template>
  <el-dialog :visible.sync="show" :show-close="false" width="530px" custom-class="face-tips-dialog">
    <div class="face-tips-card">
      <img src="@/assets/img/u14614.png" class="face-tips-robot" />
      <div class="lh35 fwb ft16">
        <div>按国家互联网平台企业涉税信息报送的人脸识别要求，</div>
        <div>
          现有 <span class="fwb color-fbff00 ft20">{{ faceData.soonCount }}</span> 人人脸信息将过期、<span
            class="fwb color-fbff00 ft20"
            >{{ faceData.unAuthCount }}</span
          >
          人未完成识别，
        </div>
        <div>为保障业务顺利开展，请尽快督促相关人员办理。</div>
      </div>
      <span class="face-tips-close" @click="handleClose"></span>
    </div>
    <div class="face-tips-footer">
      <el-button @click="handleClose">知道了，今天不再提醒</el-button>
      <el-button @click="handleGo">立即处理</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { FaceTips } from "@/api/faceTips";
import { aiUserInfo, UserInfoUpadte } from "@/api/user";

export default {
  data() {
    return {
      show: false,
      faceData: {}
    };
  },
  mounted() {
    aiUserInfo({ merchantDomain: window.location.host }).then(res => {
      if (res.data.faceCountTip == 0) {
        this.checkFaceTips();
      }
    });
  },
  methods: {
    checkFaceTips() {
      FaceTips().then(res => {
        this.faceData = res.data;
        if (this.faceData.soonCount !== 0 || this.faceData.unAuthCount !== 0) {
          this.show = true;
        }
      });
    },
    handleClose() {
      this.show = false;
      UserInfoUpadte({ merchantDomain: window.location.host }).then();
    },
    handleGo() {
      this.show = false;
      UserInfoUpadte({ merchantDomain: window.location.host }).then();
      this.$router.push("/flexibleuser/index");
    }
  }
};
</script>

<style scoped>
/* dialog 本体透明 */
::v-deep .face-tips-dialog {
  background: transparent;
  box-shadow: none;
}
::v-deep .face-tips-dialog .el-dialog__header {
  display: none;
}
::v-deep .face-tips-dialog .el-dialog__body {
  padding: 0;
  background: transparent;
  overflow: visible;
}

/* 蓝色卡片 */
.face-tips-card {
  position: relative;
  background: #3d6aff;
  border-radius: 16px;
  padding: 24px 24px 24px 110px;
  color: #fff;
  min-height: 150px;
  overflow: visible;
}

/* 机器人图片溢出卡片左侧 */
.face-tips-robot {
  position: absolute;
  top: -15px;
  left: -90px;
  bottom: 0;
  width: 185px;
}

/* 叉号关闭按钮 */
.face-tips-close {
  position: absolute;
  top: -20px;
  right: -30px;
  width: 28px;
  height: 28px;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
}
.face-tips-close::before,
.face-tips-close::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 14px;
  height: 3px;
  background: #333;
  border-radius: 2px;
}
.face-tips-close::before {
  transform: translate(-50%, -50%) rotate(45deg);
}
.face-tips-close::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

/* 按钮区：透明间距 + 两个白底按钮 */
.face-tips-footer {
  margin-top: 35px;
  display: flex;
  gap: 16px;
  justify-content: center;
}
.face-tips-footer .el-button:first-child {
  height: 45px;
  width: 220px;
  min-width: 160px;
  background: transparent;
  border: 1.5px solid #fff;
  color: #fff;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
}
.face-tips-footer .el-button:last-child {
  margin-left: 30px;
  min-width: 160px;
  background: #fff;
  border: 1px solid #fff;
  color: #000;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
}
</style>
